import translation from "../../../translations/category.json";

import SingleCategoryMobile from "./singleCategoryMobile/SingleCategoryMobile";
import SingleCategoryWeb from "./singleCategoryWeb/SingleCategoryWeb";

const SingleCategory = (props) => {
	props.addTranslation(translation);

	if (props.isMobile) {
		return <SingleCategoryMobile {...props} />;
	} else {
		return <SingleCategoryWeb {...props} />;
	}
};

export default SingleCategory;
